import {loadJsFile} from 'swayok-react-mdb-ui-kit/helpers/loadJsFile'

type RecaptchaAction = 'registration' | 'login' | 'support'

// Загрузка и работа с Recaptcha v3.
export class Recaptcha3Service {

    // Индикатор того, что JS скрипт уже загружен.
    private static isLibLoaded: boolean = false
    // Настройки.
    private static siteKey: string | null

    // Инициализация, загрузка JS файла.
    static init(siteKey: string | null): void {
        this.siteKey = siteKey

        document.body.setAttribute('data-recaptcha-badge', '1')

        if (!this.siteKey || this.isLibLoaded) {
            return
        }
        this.isLibLoaded = true

        // Добавляем метод ready, который будет заменен после загрузки Recaptcha.
        // При этом вызов этого метода до загрузки добавит callback в очередь вызовов,
        // которые будут совершены после загрузки Recaptcha.
        if (typeof window.grecaptcha === 'undefined') {
            // @ts-ignore
            window.grecaptcha = {
                ready(callback: () => unknown) {
                    if (
                        typeof window.grecaptcha === 'undefined'
                        || typeof window.grecaptcha.execute === 'undefined'
                    ) {
                        // window.__grecaptcha_cfg is a global variable that stores reCAPTCHA's
                        // configuration. By default, any functions listed in its 'fns' property
                        // are automatically executed when reCAPTCHA loads.
                        const c: string = '___grecaptcha_cfg'
                        // @ts-ignore
                        window[c] = window[c] ?? {};
                        // @ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                        (window[c].fns = window[c].fns ?? []).push(callback)
                    } else {
                        callback()
                    }
                },
            }
        }

        // Загрузка скрипта.
        void loadJsFile('https://www.google.com/recaptcha/api.js?render=' + this.siteKey)
    }

    // Сбросить Recaptcha и спрятать её иконку.
    static hide() {
        if (window.grecaptcha) {
            try {
                window.grecaptcha.reset()
            } catch (_e) {
                // Игнорируем.
            }
        }
        document.body.removeAttribute('data-recaptcha-badge')
    }

    // Запуск проверки.
    static runChallenge(action: RecaptchaAction): Promise<string | null> {
        return new Promise(resolve => {
            if (!this.siteKey) {
                console.warn('[Recaptcha] Warning: site key not provided')
                resolve(null)
                return
            }
            window.grecaptcha.ready(() => {
                if (!this.siteKey) {
                    resolve(null)
                    return
                }
                try {
                    window.grecaptcha.reset()
                } catch (_e) {
                    // Игнорируем.
                }
                window.grecaptcha.execute(this.siteKey, {
                    action,
                })
                    .then(resolve)
                    .catch(() => resolve(null))
            })
        })
    }
}
